import styled, { css } from 'styled-components';
import { setAlpha } from '../../styles/utils';
import { Button } from '../Button';
import { IconButton } from '../Button/IconButton';
import { Box, Flex } from '../Core';
import { FormControlSizes } from '../Form/types';

export const BOTTOM_SCROLL_GRADIENT_HEIGHT = 136;

export const TopScrollGradient = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: calc(env(safe-area-inset-top) + 28px);
  background: linear-gradient(
    to bottom,
    ${({ theme }) => theme.backgroundContent},
    ${({ theme }) => setAlpha(0, theme.backgroundContent)}
  );
  transition: transform 300ms linear;
  pointer-events: none;
  backdrop-filter: blur(10px);
  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 20%, rgba(0, 0, 0, 0) 100%);
  -webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 20%, rgba(0, 0, 0, 0) 100%);
`;

export const BottomScrollGradient = styled(Box)`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: ${BOTTOM_SCROLL_GRADIENT_HEIGHT}px;
  background: linear-gradient(
    to top,
    ${({ theme }) => theme.backgroundContent},
    ${({ theme }) => setAlpha(0, theme.backgroundContent)}
  );
  transition: transform 300ms linear;
  pointer-events: none;
  backdrop-filter: blur(10px);
  mask-image: linear-gradient(to top, rgba(0, 0, 0, 1) 20%, rgba(0, 0, 0, 0) 100%);
  -webkit-mask-image: linear-gradient(to top, rgba(0, 0, 0, 1) 20%, rgba(0, 0, 0, 0) 100%);
`;

export const mobileButtonShadowCSS = css`
  box-shadow: ${({ theme }) =>
    `1px 1px 1px ${setAlpha(0.25, theme.colors.white.default)} inset,2px 2px 1px ${setAlpha(
      0.05,
      theme.colors.black.default
    )} inset,-2px -2px 1px ${setAlpha(0.1, theme.colors.black.default)} inset,-1px -1px 0 ${setAlpha(
      0.1,
      theme.colors.white.default
    )} inset`};
`;

export const mobileButtonBackgroundCSS = css`
  ${mobileButtonShadowCSS}
  background: ${({ theme }) => setAlpha(0.1, theme.colors.gray['000'])};
  backdrop-filter: blur(10px);
`;

export const mobileButtonCSS = css`
  ${mobileButtonBackgroundCSS}
  transition: transform 0.2s ease-in-out, background 0.2s ease-in-out;

  @media (any-hover: hover) {
    &:hover {
      ${mobileButtonShadowCSS}
      background: ${({ theme }) => setAlpha(0.1, theme.colors.gray['000'])};
    }
  }

  &:active {
    ${mobileButtonShadowCSS}
    transform: scale(1.1);
    color: ${({ theme }) => theme.colorTextImportant};
    background: ${({ theme }) => setAlpha(0.2, theme.colors.gray['090'])};
  }
`;

export const MobileButton = styled(Button)`
  ${mobileButtonCSS}
  border-radius: 32px;
  font-weight: normal;
`;

const getSize = (size: FormControlSizes) => {
  switch (size) {
    case FormControlSizes.Large: {
      return css`
        width: 44px;
        height: 44px;
        font-size: 22px;
        line-height: 22px;
      `;
    }
    default: {
      return '';
    }
  }
};

export const MobileIconButton = styled(IconButton)`
  ${mobileButtonCSS}
  ${({ size = FormControlSizes.Default }) => getSize(size)}
  border-radius: 32px;
`;

export const MobileModalSheetActionsContainer = styled(Flex)`
  ${mobileButtonBackgroundCSS};
  border-radius: 32px;
  margin-bottom: ${({ theme }) => theme.spacing16}px;
  padding: ${({ theme }) => theme.spacing4}px;
  width: 100%;
  gap: ${({ theme }) => theme.spacing4}px;
`;
